import appSettings from '@/app-settings.json';
import { PROPERTY_DETAILS_TAB_NAMES } from '@/constants';
import { LicensePayment } from '@/top-level-tot/types';
import { smartEncodeURIComponent } from '@/utils/uri-utils';
import {
  GetContextMenuItemsParams,
  MenuItemDef,
} from '@ag-grid-community/core';

export function openPropertyInNewTab(
  params: GetContextMenuItemsParams,
  place: string,
  propertyTaxTabEnabled: boolean
): MenuItemDef {
  return {
    disabled: !params?.node?.data?.property?.propertyId || !place,
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z" />
      </svg>
    `,
    name: 'Open related property in new tab',
    action: () => {
      const transactionData: LicensePayment = params?.node?.data;
      const propertyDeckardID = smartEncodeURIComponent(
        transactionData.property.propertyId
      );

      if (propertyTaxTabEnabled) {
        const urlSearchParams = new URLSearchParams();
        /** Expecting to match the value of "certificateInfo.licenseNumber" from * the "/property/tot" API used for the property tax tab. */
        urlSearchParams.append('permit', transactionData.licenseNumber);

        const urlToEncode = `${appSettings.appDomain}/${place}/home/${propertyDeckardID}/${PROPERTY_DETAILS_TAB_NAMES.propertyOverviewTaxTab}?${urlSearchParams.toString()}`;
        const urlForNewTab = encodeURI(urlToEncode);

        window.open(urlForNewTab, '_blank')?.focus();
      } else {
        const baseURL = `${appSettings.appDomain}/${place}/home/${propertyDeckardID}/overview`;
        const urlForNewTab = encodeURI(baseURL);

        window.open(urlForNewTab, '_blank')?.focus();
      }
    },
  };
}
